export interface Bounds {
  northEast: { lat: number; lng: number }
  southWest: { lat: number; lng: number }
}

export interface Grid {
  bounds: Bounds
}

export function generateSnappedGrids(bounds: Bounds, multi = 3): Grid[] {
  // Adjusting the snapped bounds to extend past the original bounds if necessary
  const snappedNorthEast = {
    lat: Math.ceil(bounds.northEast.lat / multi) * multi,
    lng: Math.ceil(bounds.northEast.lng / multi) * multi,
  }
  const snappedSouthWest = {
    lat: Math.floor(bounds.southWest.lat / multi) * multi,
    lng: Math.floor(bounds.southWest.lng / multi) * multi,
  }

  // Calculate ranges based on adjusted snapped bounds
  const latRange = snappedNorthEast.lat - snappedSouthWest.lat
  const lngRange = snappedNorthEast.lng - snappedSouthWest.lng

  const grids: Grid[] = []

  for (let latIndex = 0; latIndex < latRange; latIndex += multi) {
    for (let lngIndex = 0; lngIndex < lngRange; lngIndex += multi) {
      const gridSouthWest = {
        lat: snappedSouthWest.lat + latIndex,
        lng: snappedSouthWest.lng + lngIndex,
      }
      const gridNorthEast = {
        lat: gridSouthWest.lat + multi,
        lng: gridSouthWest.lng + multi,
      }
      grids.push({
        bounds: {
          southWest: gridSouthWest,
          northEast: gridNorthEast,
        },
      })
    }
  }

  return grids
}
